define(["exports", "react", "./style", "../../atoms"], function (_exports, _react, _style, _atoms) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DashboardButton = void 0;
  _react = _interopRequireWildcard(_react);

  var DashboardButton = function DashboardButton(_ref) {
    var globalUrl = _ref.globalUrl;

    var _useState = (0, _react.useState)(false),
        menuIsVisible = _useState[0],
        setMenuIsVisible = _useState[1];

    var hideMenu = function hideMenu() {
      return setMenuIsVisible(false);
    };

    var showMenu = function showMenu(event) {
      stopPropagation(event);
      setMenuIsVisible(true);
    };

    var toggleMenu = function toggleMenu(event) {
      event.preventDefault();
      stopPropagation(event);
      setMenuIsVisible(!menuIsVisible);
    };

    var stopPropagation = function stopPropagation(event) {
      return event.stopPropagation();
    };

    var clickOutside = function clickOutside() {
      window.addEventListener('click', hideMenu);
      return function () {
        return window.removeEventListener('click', hideMenu);
      };
    };

    (0, _react.useEffect)(clickOutside, []);
    return /*#__PURE__*/_react.default.createElement(_style.Container, null, window.matchMedia('(max-width: 700px)').matches && /*#__PURE__*/_react.default.createElement(_atoms.NavigationLink, {
      icon: "true",
      title: "Dashboard",
      onClick: toggleMenu,
      active: "" + menuIsVisible
    }, "Dashboard", /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "chevron-down"
    })), window.matchMedia('(min-width: 700px)').matches && /*#__PURE__*/_react.default.createElement(_style.Button, {
      onClick: showMenu
    }, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "grid",
      type: "solid"
    })), /*#__PURE__*/_react.default.createElement(_style.Menu, {
      active: menuIsVisible,
      onClick: stopPropagation
    }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_atoms.NavigationLink, {
      sublink: "true",
      title: "Entrar no marketplace",
      as: _atoms.GlobalLink,
      to: "/marketplace",
      globalUrl: globalUrl
    }, "Entrar no Marketplace"))));
  };

  _exports.DashboardButton = DashboardButton;
});